import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

export const PrivateMedicalRecordsIntroDescription = () => (
  <>
    <p>
      On the following screens, we’ll ask you about other healthcare facilities
      that treated your conditions.
    </p>
    <h4>Records we can review from other healthcare providers</h4>
    <p>
      We’ll need your permission to request access to your records on your
      behalf from these other healthcare providers:
    </p>
    <ul>
      <li>Private healthcare providers (non-VA)</li>
      <li>Veteran’s Choice</li>
      <li>Vet Centers</li>
      <li>Community care providers</li>
    </ul>
    <p>
      <strong>Note:</strong> You can also submit other types of records that
      don’t fit into these categories.
    </p>
  </>
);

export default {
  uiSchema: {
    ...titleUI(
      'Information about your records from other healthcare providers',
      PrivateMedicalRecordsIntroDescription,
    ),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
